import React from 'react';

import { Link } from '@mui/material';

import classes from './NgzFooter.module.scss';
import { angularizeWithProviders } from '../../providers';
import { InfoCell } from './components/InfoCell/InfoCell';
import { VersionInfoTable } from './containers/VersionInfoTable/VersionInfoTable';
import { usePageConfig } from '../../hooks/usePageConfig';

const NgzFooter = () => {
  const { hideFooter } = usePageConfig();

  if (hideFooter) {
    return null;
  }

  return (
    <footer className={classes.footer}>
      <VersionInfoTable />

      <InfoCell
        title="Developed by:"
        info={
          <Link
            href="https://www.ekreative.com/?utm_source=backend&utm_medium=footer&utm_campaign=lifebase"
            rel="noopener"
            target="_blank"
          >
            eKreative.com
          </Link>
        }
      />
    </footer>
  );
};

angularizeWithProviders(NgzFooter, 'ngzFooter', {});

export { NgzFooter };
